import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type PersonAddProps = IconComponentBaseProps;

export const PersonAdd = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: PersonAddProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_10113_29208"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10113_29208)">
        <path
          d="M18.125 10.75H15.875C15.6625 10.75 15.4844 10.6781 15.3408 10.5343C15.1969 10.3904 15.125 10.2123 15.125 9.99976C15.125 9.78709 15.1969 9.60901 15.3408 9.46551C15.4844 9.32184 15.6625 9.25001 15.875 9.25001H18.125V7.00001C18.125 6.78751 18.1969 6.60943 18.3407 6.46576C18.4846 6.32193 18.6628 6.25001 18.8752 6.25001C19.0879 6.25001 19.266 6.32193 19.4095 6.46576C19.5532 6.60943 19.625 6.78751 19.625 7.00001V9.25001H21.875C22.0875 9.25001 22.2656 9.32193 22.4093 9.46576C22.5531 9.60959 22.625 9.78776 22.625 10.0003C22.625 10.2129 22.5531 10.391 22.4093 10.5345C22.2656 10.6782 22.0875 10.75 21.875 10.75H19.625V13C19.625 13.2125 19.5531 13.3906 19.4093 13.5343C19.2654 13.6781 19.0872 13.75 18.8748 13.75C18.6621 13.75 18.484 13.6781 18.3405 13.5343C18.1968 13.3906 18.125 13.2125 18.125 13V10.75ZM9 11.6923C8.0375 11.6923 7.21358 11.3496 6.52825 10.6643C5.84275 9.97876 5.5 9.15476 5.5 8.19226C5.5 7.22976 5.84275 6.40584 6.52825 5.72051C7.21358 5.03501 8.0375 4.69226 9 4.69226C9.9625 4.69226 10.7864 5.03501 11.4718 5.72051C12.1573 6.40584 12.5 7.22976 12.5 8.19226C12.5 9.15476 12.1573 9.97876 11.4718 10.6643C10.7864 11.3496 9.9625 11.6923 9 11.6923ZM1.5 17.7885V17.0845C1.5 16.5948 1.633 16.1413 1.899 15.724C2.165 15.3067 2.5205 14.9858 2.9655 14.7615C3.95383 14.277 4.95092 13.9136 5.95675 13.6713C6.96258 13.4289 7.977 13.3078 9 13.3078C10.023 13.3078 11.0374 13.4289 12.0433 13.6713C13.0491 13.9136 14.0462 14.277 15.0345 14.7615C15.4795 14.9858 15.835 15.3067 16.101 15.724C16.367 16.1413 16.5 16.5948 16.5 17.0845V17.7885C16.5 18.2102 16.3523 18.5688 16.0568 18.8645C15.7613 19.16 15.4026 19.3078 14.9808 19.3078H3.01925C2.59742 19.3078 2.23875 19.16 1.94325 18.8645C1.64775 18.5688 1.5 18.2102 1.5 17.7885ZM3 17.8078H15V17.0845C15 16.882 14.9413 16.6945 14.824 16.522C14.7067 16.3497 14.5474 16.209 14.3462 16.1C13.4846 15.6757 12.6061 15.3542 11.7107 15.1355C10.8152 14.917 9.91167 14.8078 9 14.8078C8.08833 14.8078 7.18475 14.917 6.28925 15.1355C5.39392 15.3542 4.51542 15.6757 3.65375 16.1C3.45258 16.209 3.29333 16.3497 3.176 16.522C3.05867 16.6945 3 16.882 3 17.0845V17.8078ZM9 10.1923C9.55 10.1923 10.0208 9.99643 10.4125 9.60476C10.8042 9.21309 11 8.74226 11 8.19226C11 7.64226 10.8042 7.17143 10.4125 6.77976C10.0208 6.38809 9.55 6.19226 9 6.19226C8.45 6.19226 7.97917 6.38809 7.5875 6.77976C7.19583 7.17143 7 7.64226 7 8.19226C7 8.74226 7.19583 9.21309 7.5875 9.60476C7.97917 9.99643 8.45 10.1923 9 10.1923Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
